import PageForm from "../../../components/pageForm/PageForm";
import { useLocation, NavLink } from "react-router-dom";
import SubNavbar from "../../../components/SubNavbar/SubNavbar";
import UseContext from "../../../hooks/useContext";
import BodyVivierRatingTempWorker from "./components/content/body.vivier-rating-temp-worker";
import { useState } from "react";
import StyledInput from "../../../components/styledInput/StyledInput";
import { SearchLoop, Filter } from "../../../assets/icons";
import FilterDropdown from "../../../components/filter/FilterDropdown";
import MediaQuery from "react-responsive";
import Button from "../../../components/button";
import BottomSheet from "../../../components/bottomSheet/BottomSheet";
import useVivierCounts from "../../../hooks/useVivierCounts";

const VivierRatingTempWorker = () => {
    const pathname = useLocation().pathname;
    const { refreshUntreated } = UseContext();
    const { nbRatingUntreatedTempWorkers, isLoading: isLoadingCounts } = useVivierCounts(refreshUntreated);
    const [search, setSearch] = useState('');
    const [statusFilter, setStatusFilter] = useState([
        { value: 'untreated', label: 'À traiter', checked: true },
        { value: 'treated', label: 'Traité', checked: false }
    ]);
    
    const treated = statusFilter.find(item => item.checked)?.value === 'treated';
    
    const handleStatusFilterChange = (newList) => {
        setStatusFilter(newList);
    };
    
    const statusFilterValue = statusFilter.find(item => item.checked)?.label || 'À traiter';

    // États pour le BottomSheet mobile
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [tempSearch, setTempSearch] = useState('');
    const [tempStatusFilter, setTempStatusFilter] = useState([...statusFilter]);

    const openFilterSheet = () => {
        setTempSearch(search);
        setTempStatusFilter([...statusFilter]);
        setIsFilterOpen(true);
    };

    const applyFilters = () => {
        setSearch(tempSearch);
        setStatusFilter(tempStatusFilter);
        setIsFilterOpen(false);
    };

    const isActiveTab = (path) => {
        return pathname.includes(path);
    };

    const getActiveTab = () => {
        if (isActiveTab('/listAllVivier')) return 'viviers';
        if (isActiveTab('/vivier-rating-temp-worker')) return 'avis';
        return 'candidats';
    };

    const activeTab = getActiveTab();

    // Tabs component for reuse
    const VivierTabs = () => (
        <div className="flex items-center gap-0">
            <NavLink
                to="/vivier"
                className={`flex items-center justify-center py-3 px-4 cursor-pointer text-sm whitespace-nowrap ${
                    activeTab === 'candidats'
                        ? 'h-9 bg-gray-100 text-gray-700 rounded-md'
                        : 'text-gray-500 hover:bg-gray-100 hover:rounded-md hover:h-9 hover:text-gray-700'
                }`}
            >
                Candidats
            </NavLink>
            <NavLink
                to="/listAllVivier"
                className={`flex items-center justify-center py-3 px-4 cursor-pointer text-sm whitespace-nowrap ${
                    activeTab === 'viviers'
                        ? 'h-9 bg-gray-100 text-gray-700 rounded-md'
                        : 'text-gray-500 hover:bg-gray-100 hover:rounded-md hover:h-9 hover:text-gray-700'
                }`}
            >
                Viviers
            </NavLink>
            <NavLink
                to="/vivier-rating-temp-worker/rating-untreated"
                className={`flex items-center justify-center py-3 px-4 cursor-pointer text-sm whitespace-nowrap ${
                    activeTab === 'avis'
                        ? 'h-9 bg-gray-100 text-gray-700 rounded-md'
                        : 'text-gray-500 hover:bg-gray-100 hover:rounded-md hover:h-9 hover:text-gray-700'
                }`}
            >
                <div className="flex gap-1 items-center">
                    <span>Avis</span>
                    {isLoadingCounts ? (
                        <span className="bg-yellow-100 text-yellow-800 rounded px-1 flex items-center justify-center min-w-[20px]">
                            ...
                        </span>
                    ) : (
                        <span className="bg-yellow-100 text-yellow-800 rounded px-1 flex items-center justify-center min-w-[20px]">
                            {nbRatingUntreatedTempWorkers}
                        </span>
                    )}
                </div>
            </NavLink>
        </div>
    );

    return (
        <>
            <PageForm>
                <SubNavbar>
                    <div className="flex justify-between items-center w-full gap-3">
                        {/* Desktop: Left side - Filters and search */}
                        <MediaQuery minWidth={768}>
                            <div className="flex-1 overflow-x-auto overflow-y-hidden" style={{ WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                                <div className="flex gap-3 items-center min-w-max">
                                    {activeTab === 'avis' && (
                                        <FilterDropdown
                                            value={statusFilterValue}
                                            list={statusFilter}
                                            onChange={handleStatusFilterChange}
                                            type="selectMultipleRadio"
                                            maxWidth="max-w-[155px]"
                                            classNameValue="text-sm h-10 px-4 flex items-center justify-center"
                                        />
                                    )}
                                    <div className="w-full tab:flex-1 tab:max-w-[400px]">
                                        <StyledInput
                                            type="text"
                                            placeholder="Rechercher..."
                                            imgFront={<SearchLoop wh={16} color="#6B7280" />}
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </MediaQuery>
                        {/* Mobile: Filter button + Tabs */}
                        <MediaQuery maxWidth={767}>
                            <div className="flex items-center gap-3 min-w-max">
                                <Button
                                    color={'SECONDARY'}
                                    size={'SM'}
                                    onClick={openFilterSheet}
                                >
                                    <Filter wh={16} color="#374151" />
                                    <span>Filtrer</span>
                                </Button>
                                <div className="h-8 w-px bg-gray-200"></div>
                                <VivierTabs />
                            </div>
                        </MediaQuery>
                        {/* Desktop: Tabs */}
                        <MediaQuery minWidth={768}>
                            <div className="flex-shrink-0 flex items-center gap-3">
                                <div className="h-8 w-px bg-gray-200"></div>
                                <VivierTabs />
                            </div>
                        </MediaQuery>
                    </div>
                </SubNavbar>
                <BodyVivierRatingTempWorker treated={treated} search={search}/>
            </PageForm>

            {/* Bottom Sheet Filtre pour mobile */}
            <BottomSheet
                isOpen={isFilterOpen}
                onClose={() => setIsFilterOpen(false)}
                title="Filtrer"
            >
                <div className="flex flex-col gap-4">
                    {/* Recherche */}
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Rechercher
                        </label>
                        <StyledInput
                            type="text"
                            placeholder="Rechercher..."
                            imgFront={<SearchLoop wh={16} color="#6B7280" />}
                            value={tempSearch}
                            onChange={(e) => setTempSearch(e.target.value)}
                        />
                    </div>

                    {/* Statut */}
                    {activeTab === 'avis' && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Statut
                            </label>
                            <div className="flex gap-4">
                                <label className="flex items-center gap-2 cursor-pointer">
                                    <input
                                        type="radio"
                                        name="status"
                                        checked={tempStatusFilter.find(item => item.value === 'untreated')?.checked}
                                        onChange={() => setTempStatusFilter([
                                            { value: 'untreated', label: 'À traiter', checked: true },
                                            { value: 'treated', label: 'Traité', checked: false }
                                        ])}
                                        className="w-4 h-4"
                                    />
                                    <span className="text-sm">À traiter</span>
                                </label>
                                <label className="flex items-center gap-2 cursor-pointer">
                                    <input
                                        type="radio"
                                        name="status"
                                        checked={tempStatusFilter.find(item => item.value === 'treated')?.checked}
                                        onChange={() => setTempStatusFilter([
                                            { value: 'untreated', label: 'À traiter', checked: false },
                                            { value: 'treated', label: 'Traité', checked: true }
                                        ])}
                                        className="w-4 h-4"
                                    />
                                    <span className="text-sm">Traité</span>
                                </label>
                            </div>
                        </div>
                    )}

                    {/* Bouton Appliquer */}
                    <div className="mt-2">
                        <Button
                            color={'PRIMARY'}
                            size={'FULL'}
                            onClick={applyFilters}
                        >
                            Appliquer
                        </Button>
                    </div>
                </div>
            </BottomSheet>
        </>
    )
}

export default VivierRatingTempWorker;